<template>
  <section class="hero-section">
    <div class="hero-bg">
      <picture>
        <source :srcset="bgImageMobile" media="(max-width: 767px)" />
        <img :src="bgImage" alt="" class="hero-bg__img" />
      </picture>
      <div class="hero-bg__overlay"></div>
    </div>

    <div class="hero-content">
      <span class="hero-eyebrow">{{ data.eyebrow }}</span>
      <h1 class="hero-title" v-html="data.title"></h1>
      <p class="hero-copy">{{ data.copy }}</p>
      <div class="hero-cta">
        <a
          class="hero-cta__btn hero-cta__btn--primary"
          :href="data.primaryLink"
        >
          {{ data.primaryText }}
        </a>
        <a
          class="hero-cta__btn hero-cta__btn--secondary"
          :href="data.secondaryLink"
        >
          {{ data.secondaryText }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  props: {
    data: {
      type: Object,
      required: true,
    },
    bgImage: {
      type: String,
      default: require("@/assets/images/homepage_hero_city_lake.jpg"),
    },
    bgImageMobile: {
      type: String,
      default: require("@/assets/images/homepage_hero_city_lake_mobile.jpg"),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.hero-section {
  position: relative;
  width: 100%;
  overflow: hidden;

  &::before {
    content: "";
    display: block;
    // padding-top: 72.222%; // 1040 / 1440
    padding-top: 45%;
  }
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        200deg,
        rgba(0, 60, 125, 0.5) 0%,
        rgba(10, 31, 53, 0.05) 42%,
        rgba(10, 31, 53, 0) 100%
      ),
      radial-gradient(
        ellipse 47% 60% at 18% 48%,
        rgba(23, 106, 153, 0.67) 0%,
        rgba(23, 106, 153, 0) 100%
      ),
      linear-gradient(
        to top,
        rgba(247, 244, 238, 1) 1%,
        rgba(247, 244, 238, 0) 23%
      );

    // ellipse 78% 78% at 18% 48%,
  }
}

.hero-content {
  position: absolute;
  bottom: 17%;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0 40px;
  box-sizing: border-box;
}

.hero-eyebrow {
  font-family: $font-family;
  font-size: 12px;
  font-weight: normal;
  color: #e8d8b3;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  margin-bottom: 24px;
}

.hero-title {
  font-family: $font-family;
  font-size: 88px;
  font-weight: 700;
  color: #ffffff;
  line-height: 0.96;
  margin: 0;
  text-align: left;
  text-shadow: 0 4px 4px rgba(23, 106, 153, 0.3);
  max-width: 760px;
  margin-bottom: 68px;
  line-height: 1;
}

.hero-copy {
  font-family: $font-family;
  font-size: 17px;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.72;
  margin: 0;
  text-shadow: 0 4px 4px rgba(23, 106, 153, 0.3);
  max-width: 620px;
  margin-bottom: 24px;
}

.hero-cta {
  display: flex;
  gap: 14px;

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 18px 24px;
    font-family: $font-family;
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.2s;

    &--primary {
      background-color: #d6b06b;
      color: #132d4a;
      font-size: 15px;
      font-weight: 600;
      border: none;

      &:hover {
        opacity: 0.9;
      }
    }

    &--secondary {
      background-color: rgba(0, 0, 0, 0.05);
      color: #ffffff;
      font-size: 15px;
      font-weight: normal;
      border: 1px solid rgba(255, 255, 255, 0.5);

      &:hover {
        background-color: rgba(255, 255, 255, 0.08);
      }
    }
  }
}

// 平板适配
@media (max-width: 1199px) and (min-width: 768px) {
  .hero-content {
    padding: 60px 32px 0;
  }

  .hero-title {
    font-size: 60px;
    max-width: 600px;
  }

  .hero-copy {
    max-width: 500px;
  }
}

// 手机适配
@media (max-width: 767px) {
  .hero-section::before {
    padding-top: 148.717%; // 580 / 390
  }

  .hero-content {
    bottom: 8%;
    padding: 0 20px;
    justify-content: flex-end;
  }

  .hero-eyebrow {
    font-size: 11px;
    margin-bottom: 16px;
  }

  .hero-title {
    font-size: 40px;
    line-height: 1.2;
    max-width: 290px;
    margin-bottom: 35px;
  }

  .hero-copy {
    font-size: 14px;
    line-height: 1.5;
    max-width: 270px;
    margin-bottom: 16px;
  }

  .hero-cta {
    gap: 14px;

    &__btn {
      font-size: 14px;
      // padding: 18px 24px;
      padding: 15px;
    }
  }
}
</style>
